import React, { Component } from 'react'
import { RightArrowIcon, LeftArrowIcon } from '@ow/icons'
import qs from 'qs'
import dayjs from 'dayjs'
import Loading from '../loading'
import Header from './Header'
import ShowFile from './ShowFile'
import { StyledContainer, StyledFile } from './styled'

class Preview extends Component {
  constructor() {
    super()
    this.state = {
      files: [],
      currentFile: null,
      index: 0,
      isShowWatermark: true,
      updateImg: null,
      closeCallBack: null,
      isMark: false,
      loading: true,
    }
    // this.removeFile = this.removeFile.bind(this)
  }

  // 添加文件
  // eslint-disable-next-line react/no-unused-class-component-methods
  addFile(v, num, isWater, updateImg, closeCallBack) {
    const water = isWater === undefined ? true : isWater
    this.setState({ files: v })
    this.setState({ currentFile: v[num || 0] })
    this.setState({ index: num || 0 })
    this.setState({ isShowWatermark: water })
    this.setState({ updateImg })
    this.setState({ closeCallBack })
  }

  // 移除文件
  removeFile() {
    this.setState({
      files: [],
    })
  }

  showWatermark(isShow) {
    this.setState({
      isShowWatermark: isShow,
    })
  }

  render() {
    const {
      files,
      currentFile,
      index,
      isShowWatermark,
      updateImg,
      isMark,
      loading,
      closeCallBack,
    } = this.state
    const { showInfo } = currentFile || {}

    const getQuery = () => {
      if (!document || !document.location) {
        return {}
      }
      return qs.parse(document.location.search.split('?')[1])
    }
    const { tpl } = getQuery()

    console.log('state====', this.state, tpl)
    if (files.length > 0) {
      return (
        <StyledContainer className="fixed left-0 top-0 flex flex-col items-center justify-center w-screen h-screen">
          <Header
            currentFile={currentFile}
            isShowWatermark={isShowWatermark}
            onClose={() => {
              this.removeFile()
              this.setState({
                isMark: false,
              })
              if (closeCallBack) {
                closeCallBack()
              }
            }}
          />
          {showInfo && (
            <div
              className="absolute left-0 top-0 w-full flex items-center justify-center gap-2 text-white"
              style={{
                color: 'red',
                fontWeight: 'bold',
                zIndex: '9995',
                marginTop: '120px',
              }}
            >
              {showInfo.map((v) => {
                return (
                  <span>
                    {v.title}:{v.value}
                  </span>
                )
              })}
            </div>
          )}
          {!showInfo && tpl === 'ydspxj' && currentFile && (
            <div
              className="absolute left-0 top-0 w-full flex items-center justify-center gap-2 text-white"
              style={{
                color: 'red',
                fontWeight: 'bold',
                zIndex: '9995',
                marginTop: '120px',
              }}
            >
              <span>
                指标:
                {currentFile.data.standard
                  ? (
                      (currentFile.data.standard || []).map((s) => {
                        return s.map((ss) => {
                          return ss.label
                        })
                      }) || []
                    ).join('-')
                  : '无'}
              </span>
              <span>
                地址:
                {currentFile.data.lnglat_text || '无'}
              </span>
              <span>
                检查时间:
                {currentFile.data.createdAt
                  ? dayjs(currentFile.data.createdAt).format(
                      'YYYY-MM-DD HH:mm:ss'
                    )
                  : '无'}
              </span>
            </div>
          )}
          <div
            className="w-full flex flex-row items-center justify-between px-8 relative"
            style={{ height: 'calc(100% - 128px)' }}
          >
            {loading && currentFile.switchNextDataMedia && (
              <div
                className="w-full h-full absolute top-0 left-0 flex items-center justify-center"
                style={{ zIndex: '99999' }}
              >
                <Loading label="加载中..." color="#0152d9" />
              </div>
            )}
            <div className="w-10" style={{ zIndex: '9999' }}>
              {/* 上一个文件 */}
              {index > 0 && (
                <div
                  className="text-gray-200 cursor-pointer pre-btn"
                  onClick={() => {
                    this.setState({ index: index - 1 })
                    this.setState({ currentFile: files[index - 1] })
                    this.setState({
                      isMark: false,
                    })
                  }}
                >
                  <LeftArrowIcon height={12} width={12} fill="#fff" />
                </div>
              )}
            </div>
            <StyledFile className="show-file w-4/5 h-4/5 flex items-center justify-center">
              <ShowFile
                currentFile={currentFile}
                isShowWatermark={isShowWatermark}
                isMark={isMark}
                loading={loading}
                setIsLoading={(v) => {
                  this.setState({
                    loading: v,
                  })
                }}
                setIsMark={(v) => {
                  this.setState({
                    isMark: v,
                  })
                }}
                showWatermark={(e) => {
                  this.showWatermark(e)
                }}
                updateImg={(_files, _currentFile, onCancle) => {
                  updateImg(_files, _currentFile, onCancle, index)
                }}
              />
            </StyledFile>
            {currentFile.switchNextDataMedia ? (
              <div className="w-10" style={{ zIndex: '9999' }}>
                {/* 下一个文件 */}
                {index < files.length - 1 ? (
                  <div
                    className="text-gray-200 cursor-pointer pre-btn"
                    onClick={() => {
                      this.setState({ index: index + 1 })
                      this.setState({ currentFile: files[index + 1] })
                      this.setState({
                        isMark: false,
                      })
                    }}
                  >
                    <RightArrowIcon height={12} width={12} fill="#fff" />
                  </div>
                ) : (
                  <div
                    title="切换下一条数据"
                    className="text-gray-200 cursor-pointer pre-btn"
                    onClick={() => {
                      currentFile.switchNextDataMedia()
                      this.setState({
                        isMark: false,
                        loading: true,
                      })
                    }}
                  >
                    <RightArrowIcon height={12} width={12} fill="#fff" />
                  </div>
                )}
              </div>
            ) : (
              <div className="w-10" style={{ zIndex: '9999' }}>
                {/* 下一个文件 */}
                {index < files.length - 1 && (
                  <div
                    className="text-gray-200 cursor-pointer pre-btn"
                    onClick={() => {
                      this.setState({ index: index + 1 })
                      this.setState({ currentFile: files[index + 1] })
                      this.setState({
                        isMark: false,
                      })
                    }}
                  >
                    <RightArrowIcon height={12} width={12} fill="#fff" />
                  </div>
                )}
              </div>
            )}
          </div>
        </StyledContainer>
      )
    }
    return null
  }
}

export default Preview
